import { TriangleAlert } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Typography } from '@/components/ui/typography';
import { integrationStatusCopy as copy } from './copy';

interface Props { vendorName: string; onDisable: () => void }

/** Distinct lower-page action, not an inline toggle (DV-2549 AC). Rendered only for active + canManage. */
export const DangerZoneCard = ({ vendorName, onDisable }: Props) => (
  <section aria-labelledby="danger-zone-heading" className="mx-5 mb-5 overflow-hidden rounded-xl border border-destructive/40 bg-card">
    <div className="flex items-center gap-2 border-b border-destructive/30 bg-destructive-soft px-4 py-3 text-destructive">
      <TriangleAlert className="size-4.5" aria-hidden="true" />
      <Typography as="h2" id="danger-zone-heading" variant="heading-md" className="text-destructive">{copy.dangerZone.heading}</Typography>
    </div>
    <div className="flex flex-col gap-3 p-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex flex-col gap-0.5">
        <Typography variant="body-semibold">{copy.dangerZone.title}</Typography>
        <Typography variant="body" className="text-muted-foreground">{copy.dangerZone.body(vendorName)}</Typography>
      </div>
      <Button type="button" variant="outline" onClick={onDisable} className="border-destructive text-destructive hover:bg-destructive-soft hover:text-destructive shrink-0">
        {copy.dangerZone.button}
      </Button>
    </div>
  </section>
);
